import React, { useState, useEffect, forwardRef, useImperativeHandle } from 'react';
import 'devextreme-react/text-area';
import ScrollView from 'devextreme-react/scroll-view';
// import Form, { Item, RequiredRule, Label } from 'devextreme-react/form';
import { RadioGroup } from 'devextreme-react/radio-group';
import { Popup, ToolbarItem } from 'devextreme-react/popup';
import { Button } from 'devextreme-react/button';
import NewFormatExport from '../new-format-export/new-format-export'
import { exportDataGrid } from 'devextreme/excel_exporter';
import ResponsiveBox, { Row, Col, Item, Location } from 'devextreme-react/responsive-box';
import ExcelJS from 'exceljs';
import saveAs from 'file-saver';
import './export-dialog.scss';

const ExportDialog = forwardRef((props, ref) => {
    const { dataExport ,selectedRowsData } = props;

    let countRow = selectedRowsData.length;
    let countAllData = (dataExport?.component.getDataSource().items()) ? dataExport?.component.getDataSource().items().length : 0 

    const selectionOne = [
        { text: `Only export (${countRow}) records that are curently selected`, value: 0 },
        { text: `Export all (${countAllData}) records in the current view`, value: 1 }
    ]
    const selectionTwo = [
        { "text": `Export orders`, "value": 0 },
        { "text": `Export order line items`, "value": 1 }
    ]
    const selectionThree = [
        { "text": `Export my current view`, "value": 0 }
    ]
    
    const [valueSelectionOne, setValueSelectionOne] = useState(0);
    const [valueSelectionTwo, setValueSelectionTwo] = useState(0);
    const [valueSelectionThree, setValueSelectionThree] = useState(0);
    const [isPopUpExportFormat, setIsPopUpExportFormat] = useState(false);
    const [valDataHeader, setValDataHeader] = useState([]);

    const itemRender = (item) => {
        const itemsStyle = { margin: '5px', fontSize: '16px' }
        return (
            <>
                <p style={itemsStyle}>{item.text}</p>
            </>
        );
    }    

    const exportDataAct = async () => {
        //console.log('export data act')
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Main sheet');
        let dataColumn = (valueSelectionOne == 0) ? selectedRowsData : dataExport?.component.getDataSource().items()
        
        let newOrder = []

        dataColumn.map((item) => {
            item.sku.map((k) => {
                let j = {
                    orderNo: item.orderNo,
                    orderDate: item.orderDate,
                    orderTotal: k.quantity,
                    name: item.name,
                    phone: item.phone,
                    company: item.company,
                    addressLine1: item.addressLine1,
                    addressLine2: item.addressLine2,
                    addressLine3: item.addressLine3,
                    city: item.city,
                    state: item.state,
                    postalCode: item.zipCode,
                    countryCode: item.country,
                    itemSKU: k.sku,
                    itemName: k.name,
                    itemQuantity: k.quantity
                }
                newOrder.push(j)
            })
        })
        worksheet.columns = [
            { header: 'Order No', key: 'orderNo', width: 15, },
            { header: 'Order Date', key: 'orderDate', width: 15, },
            { header: 'Order Total', key: 'orderTotal', width: 15, },
            { header: 'Recipient Full Name', key: 'name', width: 10 },
            { header: 'Recipient Phone', key: 'phone', width: 32 },
            { header: 'Recipient Company', key: 'company', width: 15, },
            { header: 'Address Line 1', key: 'addressLine1', width: 15, },
            { header: 'Address Line 2', key: 'addressLine2', width: 15, },
            { header: 'Address Line 3', key: 'addressLine3', width: 15, },
            { header: 'City', key: 'city', width: 15, },
            { header: 'State', key: 'state', width: 15, },
            { header: 'Postal Code', key: 'postalCode', width: 15, },
            { header: 'Country Code', key: 'countryCode', width: 15, },
            { header: 'Item SKU', key: 'itemSKU', width: 15, },
            { header: 'Item Name', key: 'itemName', width: 15, },
            { header: 'Item Quantity', key: 'itemQuantity', width: 15, }           
        ];

        newOrder.map((item) => {
            worksheet.addRow(item);
        })        
        
        // save under export.xlsx
        workbook
            .csv
            .writeBuffer()
            .then(function (buffer) {
                saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'DataGrid.csv');
            });
    }

    const NewExportNameBtn = {
        text: 'Save Export Format',
        useSubmitBehavior: true,
        onClick: (e) => console.log('submit ditekan!')
    }

    const NewExportNameCancelBtn = {
        text: 'Back',
        onClick: (e) => setIsPopUpExportFormat(false)
    }

    const SaveExportFormatBtn = {
        text: 'Save Export Format',
        stylingMode: 'outlined',
        useSubmitBehavior: true,
        onClick: (e) => console.log('save export format')
    }

    const CreateNewFormatBtn = () => {
        let dataColumn = dataExport?.component.getDataSource().items()
        let dataHeader = []
            dataHeader = Object.keys(dataColumn[0])

        setValDataHeader(dataHeader)
        setIsPopUpExportFormat(true)
    }

    useImperativeHandle(ref, (e) => ({ exportDataAct }));

    return (
        <React.Fragment>
            <ScrollView>
                <ResponsiveBox>
                    <Row />
                    <Row />
                    <Row />
                    <Col ratio={1} />
                    <Col ratio={0.4} />
                    <Item>
                        <Location row={0} col={0} colspan={2} />
                        <h3 style={{fontSize: 22, marginTop: 20}}>Which records would you like to export?</h3>
                        <RadioGroup
                            dataSource={selectionOne}
                            value={valueSelectionOne}
                            itemRender={itemRender}
                            valueExpr={'value'}
                            onValueChanged={e => setValueSelectionOne(e.value)}
                        />                            
                    </Item>
                    <Item>
                        <Location row={1} col={0} colspan={2} />
                        <h3 style={{ fontSize: 22, marginTop: 20 }}>How would you like to export these</h3>
                        <RadioGroup
                            dataSource={selectionTwo}
                            value={valueSelectionTwo}
                            itemRender={itemRender}
                            valueExpr={'value'}
                            onValueChanged={e => setValueSelectionTwo(e.value)}
                        />                     
                    </Item> 
                    <Item>
                        <Location row={2} col={0} />
                        <div style={{marginTop: 20}}>
                            <h3 style={{ fontSize: 22 }}>What format do you want exported?</h3>
                            <RadioGroup
                                dataSource={selectionThree}
                                itemRender={itemRender}
                                valueExpr={'value'}
                                value={valueSelectionThree}
                            />
                        </div>                                                    
                    </Item>
                    <Item>
                        <Location row={2} col={1} />
                        <div style={{marginTop: 20}}>
                            <Button
                                text="Create New Format"
                                onClick={() => CreateNewFormatBtn()}
                                render={(buttonData) => <small>{buttonData.text}</small>}
                            />
                        </div>
                    </Item>                               
                </ResponsiveBox>
                <Popup id="NewFormatExportPopUp"
                    visible={isPopUpExportFormat}
                    onHiding={e => { setIsPopUpExportFormat(false) }}
                    showTitle={true}
                    width={700}
                    title="New Format Export">
                    <NewFormatExport dataHeader={valDataHeader} />
                    <ToolbarItem
                        widget="dxButton"
                        location="after"
                        toolbar='bottom'
                        options={NewExportNameCancelBtn}></ToolbarItem>
                    <ToolbarItem
                        widget="dxButton"
                        location="after"
                        toolbar='bottom'
                        options={SaveExportFormatBtn}></ToolbarItem>                        
                </Popup>                
            </ScrollView>
        </React.Fragment>
    )

})

export default ExportDialog;